import {
  SUBSCRIPTION_PAYMENT_FAILED_MESSAGE,
  SUBSCRIPTION_PAYMENT_FAILED_PATH,
} from "./paymentFailure";
import {
  Box,
  Button,
  IconButton,
  Popover,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { ErrorOutlineIcon } from "components/ui/icons";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

type SubscriptionPaymentFailedIndicatorProps = {
  fullWidth?: boolean;
};

const SubscriptionPaymentFailedIndicator = ({
  fullWidth = false,
}: SubscriptionPaymentFailedIndicatorProps) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const openPopover = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closePopover = () => {
    setAnchorEl(null);
  };

  const trigger = fullWidth ? (
    <Button
      color="warning"
      variant="contained"
      fullWidth
      startIcon={<ErrorOutlineIcon />}
      onClick={openPopover}
      aria-label="Payment failed"
    >
      Payment failed
    </Button>
  ) : (
    <Tooltip title="Payment failed">
      <IconButton
        color="warning"
        onClick={openPopover}
        aria-label="Payment failed"
        size="large"
      >
        <ErrorOutlineIcon />
      </IconButton>
    </Tooltip>
  );

  return (
    <>
      {trigger}
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closePopover}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Box sx={{ p: 3, maxWidth: 320 }}>
          <Stack spacing={2}>
            <Typography variant="subtitle1" fontWeight={700}>
              Payment failed
            </Typography>
            <Typography color="text.secondary">
              {SUBSCRIPTION_PAYMENT_FAILED_MESSAGE}
            </Typography>
            <Button
              component={RouterLink}
              to={SUBSCRIPTION_PAYMENT_FAILED_PATH}
              onClick={closePopover}
              variant="contained"
            >
              Review subscription
            </Button>
          </Stack>
        </Box>
      </Popover>
    </>
  );
};

export default SubscriptionPaymentFailedIndicator;
